const stateManager = require('../state/stateManager.js');

const stringUtil = require('../string/stringUtil.js');
const configurationManager = require('../config/configurationManager.js');

const logger = require('../logger/logger.js');
const utils = require('../logger/utils');

function getCompleteUrl(url)
{
    if (stringUtil.isStringNullOrEmpty(url))
        return url;

    return `${configurationManager.getAppConfig().integrationServer}/${configurationManager.getAppConfig().webOrderingGateway}/${url}`;
}

function getHttpHeader(url, verb)
{
    const state = stateManager.getStore().getState();
    return ({
        "Content-Type": "application/json",
        "x-token": configurationManager.getAppConfig().webOrderingGatewayTokenId,

        "applicationId": state.applicationId,
        "applicationMode": state.currentMode,
        "franchisorId": state.franchisorId,
        "franchiseeId": state.franchiseeId,
        "propertyId": state.propertyId,
        "storefrontId": state.storefront?.id,
        "tableNumber": state.tableNumber,
        "tracing-context": JSON.stringify(utils.createTracingContext(url, verb))
    });
}

module.exports.post = function (resourceUrl, body)
{
    return executeFetch(resourceUrl, 'POST', body);
}

module.exports.delete = function (resourceUrl, body)
{
    return executeFetch(resourceUrl, 'DELETE', body);
}

module.exports.get = function (resourceUrl)
{
    return executeFetch(resourceUrl, 'GET');
}

module.exports.put = function (resourceUrl, body)
{
    return executeFetch(resourceUrl, 'PUT', body);
}


function executeFetch(resourceUrl, method, body)
{
    const requestBody = {};
    requestBody.method = method;
    requestBody.headers = getHttpHeader(resourceUrl, method);
    if (body) requestBody.body = JSON.stringify(body);

    const completeUrl = getCompleteUrl(resourceUrl);

    if (stringUtil.isStringNullOrEmpty(completeUrl))
        return Promise.reject("Resource URL is either null or empty");

    return doFetch(completeUrl, requestBody);
}

function doFetch(completeUrl, requestBody, attempts = 1)
{
    var tracingContext = JSON.parse(requestBody.headers["tracing-context"]);
    logger.info(`Sending request to URL: ${completeUrl}`, tracingContext);

    let errorMessage;

    var appConfig = configurationManager.getAppConfig();

    return fetch(completeUrl, requestBody)
            .then(
            response =>
            {
                if (response.status < 200 || response.status > 299)
                {
                    if (response.status != 400 && response.status != 401 && response.status != 404 && 
                        response.status != 500 && stringUtil.areStringSame(requestBody.method, "PUT") && attempts <= appConfig.webOrderingMinimumNoOfAttemptsForApi)
                    {
                        logger.error(`API doFetch failed with attempt (${attempts}). Trying one more time.`, tracingContext); 
                        attempts = attempts + 1;
                        return sleep(appConfig.webOrderingMinimumApiReAttemptWaitTimeInMs).then(response => {return doFetch(completeUrl, requestBody, attempts)});
                    }

                    if (response.status == 404)
                    {
                        const errorMessage = `Resource URL '${completeUrl}' does not exist on server with method '${requestBody.method}'.`;
                        logger.error(errorMessage, tracingContext);
                        return Promise.reject(errorMessage);
                    }
                    errorMessage = `HTTP Error: Status Code = ${response.status}, Resource URL '${completeUrl}'`;
                    logger.error(errorMessage, tracingContext);

                    return response.text()
                        .then(text => Promise.reject(text || errorMessage));
                }

                return response.json();
            },
            error =>
            {
                if (stringUtil.areStringSame(requestBody.method, "PUT") && attempts <= appConfig.webOrderingMinimumNoOfAttemptsForApi)
                {
                    logger.error(`API doFetch failed with attempt (${attempts}). Trying one more time.`, tracingContext, error);
                    attempts = attempts + 1;
                    return sleep(appConfig.webOrderingMinimumApiReAttemptWaitTimeInMs).then(response => {return doFetch(completeUrl, requestBody, attempts)});
                }
                
                errorMessage = error.message;
                if (!errorMessage) errorMessage = error;
                logger.error(`Following error reported while accessing resource URL '${completeUrl}' with method '${requestBody.method}':  ${errorMessage}`, tracingContext, error);
                return Promise.reject(errorMessage);
            })
        .then(x => new Promise(resolve => setTimeout(() => resolve(x), appConfig.webOrderingMinimumApiResultWaitTimeInMs)), error => Promise.reject(error));
}

function sleep(ms)
{
    return new Promise(resolve => setTimeout(resolve, ms));
}

